import axios, { AxiosResponse } from 'axios';

import defaultHeaders from './default-headers';

/**
 * Delete Request
 */
const deleteRequest = async (url: string, data?: any): Promise<AxiosResponse<any>> => {
  try {
    const authToken = defaultHeaders();
    const headers = {
      ...(authToken && authToken), // Add Authorization header if token exists
    };

    return await axios.delete(url, {
      headers,
      data, // Pass data for DELETE request body
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default deleteRequest;
